import { render, staticRenderFns } from "./SetUpIncome.vue?vue&type=template&id=479ae570&"
import script from "./SetUpIncome.vue?vue&type=script&lang=js&"
export * from "./SetUpIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports